<template>
    <div class="partner-logo">
        <img class="partner-logo-img" :src="logoSrc" :alt="name" draggable="false" loading="lazy" />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { PartnerLogo } from '@/data/partners'

import alicloud from '@/assets/icons/partners/official/alicloud.ico?url'
import aws from '@/assets/icons/partners/official/aws.ico?url'
import chinapost from '@/assets/icons/partners/official/chinapost.ico?url'
import evergrande from '@/assets/icons/partners/official/evergrande.ico?url'
import foxconn from '@/assets/icons/partners/official/foxconn.ico?url'
import huaweicloud from '@/assets/icons/partners/official/huaweicloud.ico?url'
import iflytek from '@/assets/icons/partners/official/iflytek.ico?url'
import jdcloud from '@/assets/icons/partners/official/jdcloud.ico?url'
import oschina from '@/assets/icons/partners/official/oschina.ico?url'
import pinduoduo from '@/assets/icons/partners/official/pinduoduo.png?url'
import tencentcloud from '@/assets/icons/partners/official/tencentcloud.ico?url'
import zhubajie from '@/assets/icons/partners/official/zhubajie.ico?url'

const OFFICIAL_URLS: Record<string, string> = {
    'alicloud.ico': alicloud,
    'aws.ico': aws,
    'chinapost.ico': chinapost,
    'evergrande.ico': evergrande,
    'foxconn.ico': foxconn,
    'huaweicloud.ico': huaweicloud,
    'iflytek.ico': iflytek,
    'jdcloud.ico': jdcloud,
    'oschina.ico': oschina,
    'pinduoduo.png': pinduoduo,
    'tencentcloud.ico': tencentcloud,
    'zhubajie.ico': zhubajie,
}

const props = defineProps<{ logo: PartnerLogo; name: string }>()

const logoSrc = computed(() => OFFICIAL_URLS[props.logo.officialFile] ?? '')
</script>

<style scoped lang="scss">
.partner-logo {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* 固定画布尺寸，彩色原图等比适配，保证每张卡片图标占位一致 */
.partner-logo-img {
    width: 72px;
    height: 72px;
    object-fit: contain;
    object-position: center;
}
</style>
